//import useToken from './useToken';



export class OtherBetService {

    getPuntajesList(token1) {
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/bets', {
        var respuesta = fetch(process.env.REACT_APP_URL+'puntajeTotalJugadores', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token1
            },
            //body: JSON.stringify(credentials)
        })
        .then(data => data.json());
        return respuesta;
	}

    newMatch(teamData, token) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/bets', {
        var respuesta = fetch(process.env.REACT_APP_URL+'bets', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(teamData)
        })
        .then(data => data.json());
        //console.log (respuesta);
        return respuesta;
    }

    getPuntajeTotal(token) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/puntajetotal', {
        var respuesta = fetch(process.env.REACT_APP_URL+'puntajetotal', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            //body: JSON.stringify(teamData)
        })
        .then(data => data.json());
        return respuesta;
    }

    downloadAuditPdf(token, scope = 'all') {
        return fetch(process.env.REACT_APP_URL+'admin/audit/bets-pdf?scope='+encodeURIComponent(scope), {
            method: 'GET',
            headers: {
                'Accept': 'application/pdf',
                'Authorization': 'Bearer '+token,
            },
        }).then(async response => {
            if (!response.ok) {
                let message = 'No se pudo generar el PDF de auditoria';
                try {
                    const data = await response.json();
                    message = data.mensaje || message;
                }
                catch (error) {}
                throw new Error(message);
            }

            const blob = await response.blob();
            const disposition = response.headers.get('Content-Disposition') || '';
            const match = disposition.match(/filename="?([^";]+)"?/);
            return {
                blob,
                filename: match ? match[1] : 'auditoria-apuestas.pdf',
            };
        });
    }

}   
